import * as Environment from "../base/Environment.js";

//
// Product
//

export const Product = function (values) {
	this.values = values;
	
	const mapping = Product.MAPPING;
	
	for (const key in mapping)
		this [key] = values [mapping [key]];
	
	if (Environment.FAST_PASS)
		this.productPageURL = "./c-demand-calculator-product-page.php";
	else if (this.productPageURL.indexOf ("//") < 0)
		this.productPageURL = null;
	
	if (this.productPageURL && location.host.indexOf ("staging.tubag.com") >= 0)
		this.productPageURL = this.productPageURL.replace ("tubag.com", "staging.tubag.com");
	
	/*
	if (Environment.FAST_PASS && this.name.indexOf ("PFK") == 0)
		this.productPageURL = null; // "404";
	*/
	
	if (this.category.indexOf ("Wasser") == 0)
		this.isWaterPermeable = this.category.indexOf ("Wasserdurchlässig") == 0;
	
	let calculationRule;
	
	switch (this.subGroup) {
		case "Fugenmörtel":
			calculationRule = "Fugenmörtel";
			break;
		
		case "Bettungsmörtel":
			calculationRule = "Bettungsmörtel";
			break;
		
		case "Fliesen- und Natursteinkleber":
		case "Haftschlämme":
		case "Fliesenkleber":
			calculationRule = "Kontaktschicht und Kleber";
			break;
		
		case "Mauermörtel":
			calculationRule = "Mauermörtel";
			break;
		
		default:
			if (this.category.indexOf ("ugenmörtel") > 0) {
				calculationRule = "Fugenmörtel";
				
			} else if (this.name.indexOf ("TKN") >= 0) {
				calculationRule = "Kontaktschicht und Kleber";
				
			} else if (this.category == "Mauermörtel") {
				calculationRule = "Mauermörtel";
				
			} else if (this.category == "Estrich/Beton") {
				calculationRule = "Mauermörtel";
				
			} else {
				trace ("missing calculation rule for", this);
				trace ("(subgroup", this.subGroup + ")", "(category", this.category + ")");
				
			}
		
	}
	
	this.calculationRule = calculationRule;
	
	Product.list.push (this);
	
};

Product.prototype.toString = function () {
	return "[Product " + this.name + "]";
	
};

Product.prototype.getNumericalProperty = function (key) {
	const value = this [key];
	return parseFloat (value.replace (",", "."));
	
};

Product.prototype.getProductPage = async function () {
	let mutex = this.mutex;
	if (!mutex)
		mutex = this.mutex = new Mutex ();
	
	const mutexRelease = await mutex.acquire ();
	
	return new Promise (async resolve => {
		let productPage = this.productPage;
		
		if (productPage === undefined) {
			const productPageURL = this.productPageURL;
			
			if (productPageURL) {
				const response = await fetch (productPageURL);
				
				if (response.status < 400) {
					const markup = await response.text ();
					productPage = this.productPage = new DOMParser ().parseFromString (
						markup, "text/html"
						
					);
					
				} else {
					const itemElement = this.itemElement;
					itemElement.className = "";
					itemElement.innerHTML = "";
					this.itemElement = null;
					
				}
				
			} else {
				productPage = this.productPage = null;
				
			}
			mutexRelease ();
			
		}
		
		resolve (productPage);
		
	});
	
};

Product.prototype.getFeatureList = async function (productPageURL) {
	return new Promise (async resolve => {
		let featureList = this.featureList;
		if (featureList === undefined) {
			const productPage = await this.getProductPage ();
			featureList = this.featureList = productPage?.querySelector (".product-feature-list > ul") || null;
			
		}
		
		resolve (featureList);
		
	});
	
};

Product.MAPPING = {
	headline: "headline",
	
	group: 1,
	subGroup: 4,
	category: 6,
	
	entryType: 7,
	unit: 9,
	name: 14,
	unitSize: 15,
	
	density: 16,
	demandPerSqareMeter: 17,
	demandWeight: 18,
	demandContainers: 19,
	
	remarks: 20,
	productPageURL: 22,
	sapCode: 23
	
};

Product.list = new Array ();

Product.loadModelData = async function (path) {
	const response = await fetch (path);
	
	if (response.status < 400) {
		const text = await response.text ();
		
		let p = "", row = [""], lines = [row],
			i = 0, r = 0, s = !0;
		
		for (let l of text) {
			if ("\"" === l) {
				if (s && l === p)
					row [i] += l;
				
				s = !s;
				
			} else if (";" === l && s) {
				l = row [++i] = "";
				
			} else if ("\n" === l && s) {
				if ("\r" === p)
					row [i] = row [i].slice (0, -1);
				
				row = lines [++r] = [l = ""];
				i = 0;
				
			} else {
				row [i] += l;
				
			}
			p = l;
			
		}
		
		const mapping = Product.MAPPING;
		let currentHeadline;
		
		lines.forEach (line => {
			const entryType = line [mapping.entryType];
			
			switch (entryType) {
				case "Überschrift":
					currentHeadline = line [mapping.name]
					break;
					
				case "Produkt":
					line.headline = currentHeadline;
					new Product (line);
					break;
				
			}
			
		});
		
		/*
		console.log ("--- durchlässig ---");
		console.log (
			Product.filteredList ({
				group: "GaLaBau-Bedarf",
				isWaterPermeable: true
				
			})
			
		);
		
		console.log ("--- undurchlässig ---");
		console.log (
			Product.filteredList ({
				group: "GaLaBau-Bedarf",
				isWaterPermeable: false
				
			})
			
		);
		
		console.log (this.list [0].getNumericalProperty ("density"));
		*/
		
	}
	
};

Product.filteredList = function (mask) {
	const filteredList = new Array ();
	
	this.list.forEach (product => {
		let matchesMask = true;
		
		for (const key in mask) {
			const value = mask [key];
			if (value != undefined &&
				product [key] != undefined &&
				product [key] != value) {
				matchesMask = false;
				break;
				
			}
			
		}
		
		if (matchesMask)
			filteredList.push (product);
		
	});
	
	return filteredList;
	
};

//
// https://www.npmjs.com/package/await-semaphore
//

class Semaphore {
    constructor(count) {
        this.tasks = [];
        this.count = count;
    }
    sched() {
        if (this.count > 0 && this.tasks.length > 0) {
            this.count--;
            let next = this.tasks.shift();
            if (next === undefined) {
                throw "Unexpected undefined value in tasks list";
            }
            next();
        }
    }
    acquire() {
        return new Promise((res, rej) => {
            var task = () => {
                var released = false;
                res(() => {
                    if (!released) {
                        released = true;
                        this.count++;
                        this.sched();
                    }
                });
            };
            this.tasks.push(task);
            window.setTimeout (
                this.sched.bind(this), 0
			);
        });
    }
    use(f) {
        return this.acquire()
            .then(release => {
            return f()
                .then((res) => {
                release();
                return res;
            })
                .catch((err) => {
                release();
                throw err;
            });
        });
    }
}
class Mutex extends Semaphore {
    constructor() {
        super(1);
    }
}
